<template>
  <!-- <div class="animated fadeInUp" id="dashboard">
    <div class="section is-relative">
      <div class="has-text-centered">
          <div class="has-text-centered"> -->
            <!-- <div class="pt-10"> -->

              <!-- add router view in here -->
              <!-- <router-view></router-view> -->

              <!-- move this block into a subview DashboardOverview.vue -->
              <div>
                <div class="hr-content has-text-centered">
                  <div
                    v-show="vendorStats.length"
                    class="d-flex row mb-50"
                  >
                      <!-- <div class="width-50 display-flex flex-column justify-content-between" style="border-right: 1px solid #b9bbbc">
                        <p class="text-bold">Daily Payment Guarantee</p>
                        <div class="doughnut-chart display-flex justify-content-center">
                          <doughnut-chart style="width: 60%" :chart-data="dailyPaymentGuarantee"></doughnut-chart>
                        </div>
                        <div class="d-flex justify-content-evenly">
                          <div class="has-text-right">
                            <p class="mb-0">GHS <span class="text-big">{{ vendorStats.guarantee_used }}</span></p>
                            <p class="mb-0 red">Used</p>
                          </div>

                          <div class="has-text-right">
                            <p class="mb-0">GHS <span class="text-big">{{ vendorStats.guarantee_left }}</span></p>
                            <p class="mb-0 green">Unused</p>
                          </div>

                        </div>
                      </div> -->
                      <div class="col-12 mb-5" v-if="loggedInUser.account && loggedInUser.account.is_payer">
                        <div class="row">
                          <div class="col-12 col-lg-6 d-flex flex-column mb-5 mb-lg-0">
                            <div class="text-left mb-2">
                              <p class="text-bold h5">Self Deposit Balance</p>
                            </div>
                            <div class="p-3 p-md-4 w-full background-light-gray rounded shadow flex-grow-1 d-flex flex-column align-items-center justify-content-around">
                              <b-skeleton-wrapper :loading="loading">
                                <template #loading>
                                  <p>
                                    <b-skeleton></b-skeleton>
                                    <b-skeleton width="25%"></b-skeleton>
                                    <b-skeleton></b-skeleton>
                                  </p>
                                </template>
                                <p class="text-big text-blue mb-2">
                                  <small v-if="walletBalances.currency">{{ walletBalances.currency.code }}</small>
                                  {{ walletBalances.topupBalance | currency }}
                                </p>
                              </b-skeleton-wrapper>
                              <router-link to="/dashboard/top-up-wallet">
                                <b-button pill class="px-5" variant="primary">Deposit Funds</b-button>
                              </router-link>
                            </div>
                          </div>

                          <div class="col-12 col-lg-6 d-flex flex-column mb-5 mb-lg-0">
                            <div class="text-left mb-2">
                              <p class="text-bold h5">Trade Finance</p>
                            </div>
                            <div class="p-3 p-md-4 w-full background-light-gray rounded shadow flex-grow-1 d-flex flex-column align-items-center justify-content-around">
                              <b-skeleton-wrapper :loading="loading">
                                <template #loading>
                                  <p>
                                    <b-skeleton></b-skeleton>
                                    <b-skeleton width="25%"></b-skeleton>
                                    <b-skeleton></b-skeleton>
                                  </p>
                                </template>
                                <p class="text-big text-blue mb-2">
                                  <small v-if="walletBalances.currency">{{ walletBalances.currency.code }}</small>
                                  {{ walletBalances.creditBalance | currency }}
                                </p>
                              </b-skeleton-wrapper>
                              <a :href="'https://finance.jetpaynow.com/?session_id=' + sessionId">
                                <b-button pill class="px-5" variant="primary">Apply For Trade Finance</b-button>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-lg-6 d-flex flex-column mb-5 mb-lg-0" v-if="loggedInUser.account && loggedInUser.account.is_vendor">
                        <div class="text-left mb-2">
                          <p class="text-bold h5">Amount to be Settled</p>
                        </div>
                        <div class="p-3 p-md-0 w-full background-light-gray rounded shadow flex-grow-1 d-flex align-items-center justify-content-center">
                          <b-skeleton-wrapper :loading="loading">
                            <template #loading>
                              <p>
                                <b-skeleton></b-skeleton>
                                <b-skeleton width="25%"></b-skeleton>
                                <b-skeleton></b-skeleton>
                              </p>
                            </template>
                            <p class="text-big text-blue">
                              <small>{{ vendorStats.currency }}</small>
                              {{ vendorStats.available_balance | currency }}
                            </p>
                          </b-skeleton-wrapper>
                        </div>
                      </div>

                      <div class="col-12 col-lg-6 d-flex flex-column mb-5 mb-lg-0" v-if="loggedInUser.account && loggedInUser.account.is_vendor">
                        <div class="text-left mb-2">
                          <p class="text-bold h5">This Month's Sales</p>
                        </div>

                        <div style="padding-top: 25px;" class="pb-4 d-flex flex-column align-items-center justify-content-between flex-grow-1 background-light-gray rounded shadow">
                          <b-skeleton-wrapper :loading="loading">
                            <template #loading>
                              <p>
                                <b-skeleton></b-skeleton>
                                <b-skeleton width="25%"></b-skeleton>
                                <b-skeleton></b-skeleton>
                              </p>
                            </template>
                          <div class="d-flex justify-content-center align-items-center flex-grow-1">
                            <!-- <span class="text-giant text-blue">33</span> -->
                            
                            <p class="text-big text-blue"><small>{{ vendorStats.currency }}</small> {{ vendorStats.month_sales | currency }}</p>
                          </div>

                          <div class="d-flex justify-content-around w-100">
                            
                            <div class="">
                              <p class="mb-0">Previous Month Sales</p>
                              
                              <p class="mb-0 green">
                                <span>{{ vendorStats.currency }}</span> {{ vendorStats.previous_month_sales | currency }}
                              </p>
                            </div>

                            <div class="">
                              <p class="mb-0">Growth From Previous Month</p>
                              <p 
                                class="mb-0"
                                :class="{
                                  'green': !isNegative(vendorStats.growth_previous_month_sales), 
                                  'red': isNegative(vendorStats.growth_previous_month_sales)
                                }"
                              >
                                {{ vendorStats.growth_previous_month_sales | currency }} %
                                <i 
                                  class="fas"
                                  :class="{
                                    'fa-chevron-down': isNegative(vendorStats.growth_previous_month_sales),
                                    'fa-chevron-up': !isNegative(vendorStats.growth_previous_month_sales)
                                  }"  
                                ></i>
                              </p>
                            </div>
                          </div>
                            </b-skeleton-wrapper>
                        </div>
                      </div>

                      <!-- <div class="col-12 col-lg-4 d-flex flex-column mb-5 mb-lg-0">
                        <div class="text-left mb-2">
                          <p class="text-bold h5">Monthly Payments Sent</p>
                        </div>
                        <div class="p-4 p-md-0 background-light-gray rounded shadow flex-grow-1 d-flex align-items-center justify-content-center">
                          <b-skeleton-wrapper :loading="loading">
                            <template #loading>
                              <p>
                                <b-skeleton></b-skeleton>
                                <b-skeleton width="25%"></b-skeleton>
                                <b-skeleton></b-skeleton>
                              </p>
                            </template>
                            <p class="text-big text-blue">
                              <small>{{ vendorStats.currency }}</small>
                              {{ vendorStats.month_payments_sent | currency }}
                            </p>
                          </b-skeleton-wrapper>
                        </div>
                      </div> -->
                  </div>
                  <div class="d-flex mb-50" v-if="loggedInUser.account && loggedInUser.account.is_vendor">
                    <router-link to="/customers/request-payment" class="flex-grow-1 flex-md-grow-0">
                      <b-button pill variant="primary" class="w-100 px-5">Request for Payment</b-button>
                    </router-link>
                  </div>

                  <div class="bg-white cool-box-shadow border-radius-15 pb-60">
                    <p class="has-text-left mb-20 mt-10 text-bold h5">Recent Transactions</p>

                    <b-tabs active-nav-item-class="nav-active-bottom" class="w-100">
                      <b-tab v-if="loggedInUser.account.is_vendor" :title-link-class="['border-0 px-5 font-weight-bold']" title="Received" @click="status = 'received'" lazy>
                        <transactions-received 
                          :masterTableProps="masterTableProps"
                        />
                      </b-tab>
                      <b-tab v-if="loggedInUser.account.is_payer" :title-link-class="['border-0 px-5 font-weight-bold']" title="Sent" @click="status = 'sent'" lazy>
                        <transactions-sent 
                          :masterTableProps="masterTableProps"
                        />
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            <!-- </div> -->
          <!-- </div>
      </div> -->
      <!-- <FooterSpacing/> -->
    <!-- </div>
  </div> -->
</template>
<script>
//import DoughnutChart from '../utils/DoughnutChart.vue';
import store from '../store';
import TransactionAPI from '../api/transactions_api';
import { tableMixin } from '../utils/table.mixin';
import spinner from '../utils/Spinner';
//import EmptyTable from '../utils/empty-table.vue';
import moment from 'moment';
import FooterSpacing from '../components/FooterMobile.vue';
import TransactionsSent from '../components/TransactionsSent.vue';
import TransactionsReceived from '../components/TransactionsReceived.vue';

export default {
  mixins: [
    tableMixin
  ],
  components: {
    //DoughnutChart,
    spinner,
    //EmptyTable,
    FooterSpacing,
    TransactionsSent,
    TransactionsReceived
  },
  data() {
    return {
      filter_mobile: {},
      search: '',
      loadingTransactions: false,
      loading: false,
      authenticated: '',
      headerTag: {
        'animated fadeIn': false,
        hidden: true,
      },
      loggedInUser: {},
      masterTableProps: {
        fields: [
          {
            key: 'created_at',
            sortable: true,
            label: 'Date'
          },
          {
            key: 'service_type.name',
            sortable: false,
            label: 'Type'
          },
          {
            key: 'service_reference',
            sortable: true,
            label: 'Number'
          },
          {
            key: 'short_id',
            sortable: false,
            label: 'JetpayID'
          },
          {
            key: 'payer_account.name',
            sortable: true,
            label: 'Payer'
          },
          {
            key: 'transaction_amount',
            sortable: false,
            label: 'Amount'
          },
          {
            key: 'status',
            sortable: false,
            label: 'Status'
          }
        ],
        resultsPerPage: 10,
        currentPage: 1,
        sortBy: 'created_at',
        sortDirection: 'asc',
        totalRows: 1,
        sortDesc: true
      },
      sessionId: null
    };
  },
  props: ['session'],
  beforeMount() {
    this.tokenizer();
    this.getCurrentUser();
    this.init();
  },
  mounted() {
    this.tokenizer();
    this.$root.$emit('showMenu');
    this.startLoading();

    if (this.loggedInUser.account.is_payer) {
      TransactionAPI.methods.getWalletBalances()
      .then(verResponse => {
      })
      .catch(error => {
          console.log('error', error);
      });
    }

    TransactionAPI.methods.getTransactions()
      .then(verResponse => {
        TransactionAPI.methods.getVendorDashboardStats();
      })
      .catch(error => {
          console.log('error', error);
      });
    
  },
  computed: {
    transactionsIsReady () {
      if (this.axiosRequestAmount == 0) {
        return false
      }

      return true
    },
    axiosRequestAmount: {
      get: function () {
        return store.state.axiosRequestAmount;
      },
      set: function (newValue) {
        store.state.axiosRequestAmount = newValue;
      }
    },
    vendorStats: {
      get: function () {
        return store.state.vendorStats;
      },
      set: function (newValue) {
        store.state.vendorStats = newValue;
      }
    },
    transactions: {
      get: function () {
        return store.state.transactions;
      },
      set: function (newValue) {
        store.state.transactions = newValue;
      }
    },
    dailyPaymentGuarantee: function () {
      const statData = store.state.vendorStats;
      
      return {
        labels: ['Used', 'Unused'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: ['#f87979','#18b291'],
            data: [
                  statData.guarantee_used, 
                  statData.guarantee_left]
          }
        ]
      };
    },
    walletBalances: {
      get: function () {
        return store.state.walletBalances;
      },
      set: function (newValue) {
        store.state.walletBalances = newValue;
      }
    }
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY h:mm A');
    },
    tokenizer() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
        window.location.href = './login';
      }
    },
    getCurrentUser() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
      } else {
        this.loggedInUser = userContext.user_digest;
        this.sessionId = userContext.session_id;
      }
    },
    init() {
      this.loadingTransactions = true
      TransactionAPI.methods.getVendorDashboardStats();
      TransactionAPI.methods.getTransactions()
      .then(verResponse => {
        this.loadingTransactions = false

      })
      .catch(error => {
          console.log('error', error);
      });
    },
    startLoading() {
      this.loading = true
      this.loadingTime = 0
    },
    isNegative(number) {
      if (number < 0) {
        return true;
      } 

      return false;
    },
    truncateString(string) {
      return string.substring(0, 15);
    }
  },
  watch: {
    vendorStats() {
      if (this.vendorStats) {
        this.loading = false
      }
    }
  }
};
</script>
<style>
@import '../assets/css/table.css';
.section .title-divider {
  margin: auto;
  width: 100px;
  height: 5px;
  background: #00a27f;
}
.light-subtitle {
  font-size: 1.5rem;
  padding: 2% 10% 2% 10%;
  margin-bottom: 0 !important;
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.text-big {
  font-size: 3em;
}
.text-blue {
  color: #0085ba;
}
.background-light-gray {
  background: #f2f2f2;
}
.red {
  color: red;
}
.green { 
  color: green;
}
.b-skeleton-wrapper {
  width: 90%;
}
.reflect-rotate {
  transform: rotate(275deg) scaleX(-1);
}
.nav-active-bottom {
  border-bottom: 4px solid #00bb5c !important;
}
@media (min-width: 768px) {
  .d-md-inline-table {
    display: inline-table !important;
  }
}
@media (max-width: 768px) {
  .rounded-pill {
    border-radius: 5px !important;
  }
}
</style>
